import { AuthProvider } from "./AuthProvider";
import { combineContexts } from "Utils/combineContexts";
import { NotificationsProvider } from "./NotificationProvider";

/* Add all high level contexts here. First in array is rendered highest in component tree, and so on... */
const providers = [NotificationsProvider, AuthProvider]; // Add new context here
export const AppContextProvider = combineContexts(...providers);
